// extracted by mini-css-extract-plugin
export var searchHeader = "_5x-0";
export var searchHeaderDark = "_5x-1";